import type { LiveClassLesson } from '@openeducation/oe-rn-shared-types';
import { atom } from 'jotai';
export const currentLiveClassLessonAtom = atom<LiveClassLesson | undefined>(
  undefined
);
